import { createSharedState } from '@ai-indeed/hooks';
import { TabEnum, type Tabs } from '../type';

export const useTab = createSharedState<Tabs>(TabEnum.FIELD_CONFIG);
